export default __webpack_public_path__ + "static/media/delete.8fec7553.svg";